// change to use locally deployed query service for semi-E2E testing (no api gateway)
export const useLocalQueryService = false;

const validEnv = (name, value) => {
  if (value) {
    return value;
  }
  console.error("Env variable " + name + " has not been set");
};

export const highchartsColors = [
  "#00C9DE","#F0CA4D","#E37B40","#ED3752","#B9ECFB","#88DEA6","#FAD19D","#F0A699"
];

export const COLORS = {
  POLY_MIDNIGHT: "#00263E",
  POLY_LAVA: "#EB3C00",
  POLY_WHITE: "#FFFFFF",
  POLY_BLACK: "#000000",
  POLY_SAND: "#EEE8D6",
  POLY_PEARL: "#D7D2CB",
  POLY_LINEN: "#A59C94",
  POLY_SLATE: "#968B8A",
  POLY_STONE: "#A5CFCB",
  POLY_SUNFLOWER: "#FDDD66",
  POLY_MINT: "#99C3A7"
}

export const CLIENT_ID = validEnv( 
  "REACT_APP_CLIENT_ID", 
  process.env.REACT_APP_CLIENT_ID
);
const ANALYTICS_API_URL = validEnv( 
  "REACT_APP_ANALYTICS_API", 
  process.env.REACT_APP_ANALYTICS_API
);
const SERVICES_API_URL = validEnv( 
  "REACT_APP_SERVICES_API", 
  process.env.REACT_APP_SERVICES_API
) + "/api/v1.0";
const AUTH_API = validEnv( 
  "REACT_APP_AUTH_API", 
  process.env.REACT_APP_AUTH_API
) + "/api";
const CONSOLE = validEnv( 
  "REACT_APP_CONSOLE", 
  process.env.REACT_APP_CONSOLE
);
/*const POLY_STYLES_VERSION = validEnv( 
  "REACT_APP_POLY_STYLES_VERSION", 
  process.env.REACT_APP_POLY_STYLES_VERSION
);*/
export const STAGE = validEnv( 
  "REACT_APP_STAGE", 
  process.env.REACT_APP_STAGE
);
const HELPURL = validEnv(
  "REACT_APP_HELP_URL",
  process.env.REACT_APP_HELP_URL
);

const ANALYTICS_API_URL_LOCALHOST = "http://localhost:8337";

export const URL = {
  OAUTH_TOKEN: AUTH_API + "/OathToken",
  OAUTH_REFRESH: AUTH_API + "/RefreshToken",
  AUTHLOGOUT: AUTH_API + "/Logout",
  ORION_OAUTH: SERVICES_API_URL + "/oauth2/authorize?response_type=code&client_id=" + CLIENT_ID,
  ORION_API: SERVICES_API_URL,
  API_GW: ANALYTICS_API_URL,
  API_GW_LOCALHOST: ANALYTICS_API_URL_LOCALHOST + "/query",
  ORIONLOGOUT: SERVICES_API_URL + "/oauth2/logout?client_id=" + CLIENT_ID,
  CHANGE_PASSWORD: SERVICES_API_URL + "/oauth2/change-password?client_id=" + CLIENT_ID + "&redirect_uri=",
  CONSOLE: CONSOLE,
  PROFILE: CONSOLE + "/tenant-portal/profile-update?redirect_uri=",
  POLY_PRIVACY_URL: "https://www.polycom.com/company/privacy.html",
  POLY_LICENSE_AGREEMENT_URL:
      "https://support.polycom.com/content/dam/polycom-support/global/documentation/3725-84356-001a_polycom_cloud_terms_of_service_v2.pdf",
  HELP: HELPURL
};

export const DEFAULT_TIME_PERIOD = "WEEK";

export const TIMEPERIOD = {
  DAY: {
    TEXT: 'TimePeriod.Today',
    ICON: 'sun',
    INTERVAL: '1h'
  },
  HOURS: {
    TEXT: 'TimePeriod.24Hours',
    ICON: 'clock',
    INTERVAL: '1h'
  },
  WEEK: {
    TEXT: 'TimePeriod.Week',
    ICON: 'arrows alternate horizontal',
    INTERVAL: '6h'
  },
  MONTH: {
    TEXT: 'TimePeriod.Month',
    ICON: 'calendar alternate',
    INTERVAL: '1d'
  },
  THREEMONTH: {
    TEXT: 'TimePeriod.3Month',
    ICON: 'calendar plus',
    INTERVAL: '7d'
  },
  SIXMONTH: {
    TEXT: 'TimePeriod.6Month',
    ICON: 'delete calendar',
    INTERVAL: '14d'
  },
  YEAR: {
    TEXT: 'TimePeriod.Year',
    ICON: 'calendar',
    INTERVAL: '28d'
  }
};

// source information to be used for Loader. This is the general source (API)
// with resources beneath it and the properties of getting those resources
let APIURL = URL.API_GW;
let tail = "";
if (useLocalQueryService) {
  APIURL = URL.API_GW_LOCALHOST;
  tail = "/v1/";
}
export const DATASOURCE = {
  CALLSREFRESH: {
    KEY: "calls/refresh",
    LOADING: "calls/loading",
    URL: APIURL + '/tenant/call/detailedList' + tail
  },
  CALLSUPDATE: {
    KEY: "calls/update",
    LOADING: "calls/loading",
    URL: APIURL + '/tenant/call/detailedList' + tail
  },
  DETAIL: {
    KEY: "detail/update",
    LOADING: "detail/loading",
    URL: APIURL + '/tenant/call/callInfo' + tail
  },
  GEOCOUNT: {
    KEY: "geocount/update",
    //RESET: "geocount/reset",
    LOADING: "geocount/loading",
    URL: APIURL + '/tenant/call/geoCount' + tail
  },
  GEOREGIONS: {
    KEY: "georegions/update",
    LOADING: "georegions/loading",
    URL: APIURL + '/tenant/call/geoRegions' + tail
  },
  SUMMARY: {
    KEY: "summary/update",
    LOADING: "summary/loading",
    URL: APIURL + '/tenant/call/summary' + tail
  },
  ACTIVE_CALLS: {
    KEY: "activeCalls/update",
    LOADING: "activeCalls/loading",
    URL: APIURL + '/tenant/call/activeCalls' + tail
  },
  LICENSE_OVERAGE: {
    KEY: "licenseOverage/update",
    LOADING: "licenseOverage/loading",
    URL: APIURL + '/tenant/call/licenseOverage' + tail
  },
  AGENT_NORMALIZER: {
    KEY: "normalizer/update",
    LOADING: "normalizer/loading",
//    URL: APIURL + '/tenant/agents/agentIdNormalizers' + tail
    // need this to point to api-gw until the query-service bug that doesn't return
    // access-control-allowed-origin for this one resource is fixed
    URL: 'https://api-gw.plcm.vc/tenant/agents/agentIdNormalizers'
  },
  TENANT_INFO: {
    KEY: "tenants/update",
    LOADING: "tentants/loading",
    URL: APIURL + "/tenant/call/tenantInfo" + tail
  },
  MODALITY: {
    KEY: "modality/update",
    LOADING: "modality/loading",
    URL: "https://aqua-analytics-modality.plcm.vc/api/HttpTrigger_FileServe"
  },
  PACKET_DATA_T: {
    KEY: "packetDataT/update",
    LOADING: "packetDataT/loading",
    RESET: "packetDataT/reset",
    URL: APIURL + "/tenant/call/packetLossTeams" + tail
  },
  PACKET_DATA_S: {
    KEY: "packetDataS/update",
    LOADING: "packetDataS/loading",
    RESET: "packetDataS/reset",
    URL: APIURL + "/tenant/call/packetLossSkype" + tail
  },
  LADDER: {
    KEY: "ladder/update",
    LOADING: "ladder/loading",
    RESET: "ladder/reset",
    URL: APIURL + "/tenant/call/callLadder" + tail
  }
};
